module.exports = __webpack_public_path__ + "img/katarina_kitchen_1.b950b89b.jpg";